module.exports = __webpack_public_path__ + "img/yingyong.f31bd1e7.svg";